export default __webpack_public_path__ + "static/media/SAL2.fe460c75.jpg";